<template>
  <component :is="color === 'white' ? PCard : 'div'" class="content-lead-form">
    <ClientOnly>
      <lazyLeadForm
        v-if="formGroupId || formId"
        :feature-flags="{ prefillByUserData: true }"
        :form-group-id="formGroupId"
        :form-id="formId"
      />
    </ClientOnly>
  </component>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";

import { PCard } from "@solvari/components";

defineProps<{
  color?: "gray" | "white";
  formGroupId?: number | null;
  formId?: number | null;
}>();

const lazyLeadForm = defineAsyncComponent(
  () => import("~/shared/components/content-blocks/leadForm.ts"),
);
</script>
